export default "__VITE_ASSET__tJ1UAQ1I__";